var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoonIcon = function SvgMoonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 .5h19v19H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.021 12.256a7.642 7.642 0 0 1-9.779-9.78l.416-1.187-1.188.422a8.847 8.847 0 1 0 11.282 11.28l.421-1.187zm-7.576 5.462a7.66 7.66 0 0 1-3.67-14.386 8.83 8.83 0 0 0 10.391 10.39 7.72 7.72 0 0 1-6.721 3.996M13.06 4.062h-1.188V2.874h1.188zm-.594 4.156H11.28V7.031h1.187zm4.156-.594h-1.187V6.437h1.187z",
    clipRule: "evenodd"
  })));
};
export default SvgMoonIcon;